<template>
  <div id="specifications-panel" v-bind:data-expanded="expanded">
    <h3 class="handle" v-on:click="expanded = !expanded"><span v-if="expanded">Dölj</span><span v-if="!expanded">Visa</span> detaljer</h3>
    <button class="print" onclick="print()">Skriv ut</button>
    <img class="print-logo print-only" src="act-logo-byline.svg" alt="ACT">
    <div class="specifications" v-html="html"></div>
  </div>
</template>
<script>
export default {
  name: 'SpecificationPanel',
  props: {
    html: String,
  },
  data: function() {
    return {
      expanded: false,
      // sectionStyle: Object,
      // levelStyle: Object,
    }
  },
}
</script>
<style lang="scss">
  @mixin mobile {
    @media (max-width: 767px) {
      @content;
    }
  }
  
  #specifications-panel {
    background: #fff;
    position: fixed;
    top: calc( 100vh - 50px);
    bottom: 0px;
    left: 25vw;
    right: 25vw;
    text-align: left;
    padding: 0.7em 1em 1em;
    transition: all 0.25s;
    z-index: 120;
    overflow-y: scroll;

    @include mobile {
      top: auto;
      left: 0px;
      right: 0px;
      padding-top: 5px;
      padding-bottom: 5px;
      z-index: 7;
      bottom: 90px;
      max-height: 31px;
    }

    &[data-expanded="true"] {
      top: 10vh;
      box-shadow: 0px 0px 32px rgba(0,0,0,0.1);

      @include mobile {
        left: 0px;
        max-height: 90vh;
        padding-bottom: 100px;
      }
    }
    
    h1 {
      border-bottom: 2px solid #FF6720;

      @include mobile {
        font-size: 1.5em;
      }
    }

    h2 {
      margin-bottom: 0.15em;
    }

    h3 {

      &.handle {
        cursor: pointer;
        text-align: center;
      }

      @include mobile {
        padding: 0;
      }
    }

    .print-logo {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 100px;
      height: auto;
    }

    .print-only {
      display: none;
    }

    .print {
      position: absolute;
      top: 70px;
      right: 15px;

      @include mobile {
        top: 45px;
      }
    }

    p {
      margin: 0;
    }

    ul {
      margin: 0;
      padding: 0;

      &.item-list {
        padding-left: 0.05em;

        > li {
          border-left: 0.25em solid #FF6720;
          padding-left: 0.5em;
          padding: 0.15em 0 0.15em 0.5em;
          margin-bottom: 0.5em;
        }
      }

      li {
        list-style-type: none;
      }
      .item {
      }

      .split-item {
        display: flex;
        flex-wrap: nowrap;

        > * {
          width: 50%;
        }
      }

      ul {
        li {
          list-style: none;
        }
      }
    }
  }
</style>